(function () {
  if (window.__variantAutoAdvanceLoaded || typeof document === 'undefined') return;
  window.__variantAutoAdvanceLoaded = true;

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var picker = target.closest('variant-selects[data-auto-advance-unavailable="true"]');
      if (!picker || !picker.contains(target)) return;
      if (!target.matches('input[type="radio"], select')) return;

      advanceUnavailableSelection(picker, target);
    },
    true
  );

  function advanceUnavailableSelection(picker, changedControl) {
    var variants = getVariants(picker);
    var groups = getOptionGroups(picker);
    if (variants.length === 0 || groups.length < 2) return;

    var selectedValues = groups.map(getSelectedValue);
    if (selectedValues.some(isBlank)) return;

    var selectedVariant = findVariant(variants, selectedValues);
    if (selectedVariant && selectedVariant.available) return;

    var changedIndex = getChangedGroupIndex(groups, changedControl);
    var targetIndex = getSizeGroupIndex(groups, changedIndex);
    if (targetIndex < 0 || targetIndex === changedIndex) return;

    var nextValue = findNextAvailableValue(variants, groups[targetIndex], selectedValues, targetIndex);
    if (isBlank(nextValue) || nextValue === selectedValues[targetIndex]) return;

    selectGroupValue(groups[targetIndex], nextValue);
  }

  function getVariants(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return [];

    try {
      var variants = JSON.parse(script.textContent);
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  function getOptionGroups(picker) {
    return Array.prototype.slice
      .call(picker.querySelectorAll('.product-form__input'))
      .map(function (element) {
        var select = element.querySelector('select');
        var inputs = Array.prototype.slice.call(element.querySelectorAll('input[type="radio"]'));
        var label = element.querySelector('.form__label');

        return {
          element: element,
          select: select,
          inputs: inputs,
          label: label ? label.textContent.trim() : '',
          name: select ? select.name : inputs[0] ? inputs[0].name : ''
        };
      })
      .filter(function (group) {
        return group.select || group.inputs.length > 0;
      });
  }

  function getSelectedValue(group) {
    if (group.select) return group.select.value;

    var checkedInput = group.inputs.find(function (input) {
      return input.checked;
    });
    return checkedInput ? checkedInput.value : null;
  }

  function getChangedGroupIndex(groups, changedControl) {
    return groups.findIndex(function (group) {
      return group.element.contains(changedControl);
    });
  }

  function getSizeGroupIndex(groups, changedIndex) {
    var sizePattern = /\bsize\b|sizes|尺码|尺寸|大小/i;
    var sizeIndex = groups.findIndex(function (group) {
      return sizePattern.test(group.label) || sizePattern.test(group.name);
    });

    if (sizeIndex >= 0) return sizeIndex;
    if (changedIndex >= 0 && changedIndex < groups.length - 1) return changedIndex + 1;
    return groups.length - 1;
  }

  function findNextAvailableValue(variants, targetGroup, selectedValues, targetIndex) {
    var values = getGroupValues(targetGroup);
    var currentIndex = values.indexOf(selectedValues[targetIndex]);
    var orderedValues =
      currentIndex >= 0 ? values.slice(currentIndex + 1).concat(values.slice(0, currentIndex)) : values;

    return orderedValues.find(function (value) {
      var candidateValues = selectedValues.slice();
      candidateValues[targetIndex] = value;

      var candidateVariant = findVariant(variants, candidateValues);
      return candidateVariant && candidateVariant.available;
    });
  }

  function getGroupValues(group) {
    var values = group.select
      ? Array.prototype.slice.call(group.select.options).map(function (option) {
          return option.value;
        })
      : group.inputs.map(function (input) {
          return input.value;
        });

    return values.filter(function (value, index) {
      return values.indexOf(value) === index;
    });
  }

  function selectGroupValue(group, value) {
    if (group.select) {
      Array.prototype.forEach.call(group.select.options, function (option) {
        var selected = option.value === value;
        option.selected = selected;
        option.toggleAttribute('selected', selected);
      });
      group.select.value = value;
      return;
    }

    group.inputs.forEach(function (input) {
      var checked = input.value === value;
      input.checked = checked;
      input.toggleAttribute('checked', checked);
    });
  }

  function findVariant(variants, selectedValues) {
    return variants.find(function (variant) {
      var variantOptions = getVariantOptions(variant);
      return selectedValues.every(function (value, index) {
        return variantOptions[index] === value;
      });
    });
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (option) {
      return !isBlank(option);
    });
  }

  function isBlank(value) {
    return value === null || typeof value === 'undefined' || value === '';
  }
})();
